import http from "../plugins/axios"

export const getCertificateByCode = async (code) => {
  try {
    const response = await http.get(`/certificates/code/${code}`)
    return response
  } catch(error) {
    throw error
  }
}

export const validateCertificate = async (payload) => {
  try {
    const response = await http.post(`/certificates/validate`, payload)
    return response
  } catch(error) {
    throw error
  }
}
